const autoFetchedCountByResultName = {};

export function getAutoFetchedCount({ resultName }) {
  return autoFetchedCountByResultName[resultName] || 0;
}

export function incrementAutoFetchedCount({ resultName }) {
  if (!autoFetchedCountByResultName[resultName]) {
    autoFetchedCountByResultName[resultName] = 1;
  } else {
    autoFetchedCountByResultName[resultName] += 1;
  }
}

export function resetAutoFetchedCount() {
  Object.keys(autoFetchedCountByResultName).forEach((resultName) => delete autoFetchedCountByResultName[resultName]);
}
